import React from 'react';
import { Button, BUTTON_THEMES, Modal, ELEMENT_SIZE } from 'ht-styleguide';

export const MODAL_TYPES = {
  SERVICE: 'service',
  MEMBERSHIP: 'membership',
} as const;

type ModalType = (typeof MODAL_TYPES)[keyof typeof MODAL_TYPES];

type TRemoveItemModalProps = {
  isVisible: boolean;
  hide: () => void;
  onConfirm: () => void;
  type?: ModalType;
};

const RemoveItemModal: React.FC<TRemoveItemModalProps> = ({ isVisible, hide, onConfirm, type = MODAL_TYPES.SERVICE }) => (
  <Modal
    isVisible={isVisible}
    hide={hide}
    header={`Are you sure you want to remove this ${type}?`}
    elementSize={ELEMENT_SIZE.MEDIUM}
    footerElement2={
      <Button theme={BUTTON_THEMES.SECONDARY} onClick={hide}>
        Cancel
      </Button>
    }
    footerElement3={
      <Button theme={BUTTON_THEMES.PRIMARY} onClick={onConfirm}>
        Remove
      </Button>
    }
  />
);

export default RemoveItemModal;
